import { render, staticRenderFns } from "./DemoTokenForm.vue?vue&type=template&id=70dc8d0e&scoped=true"
import script from "./DemoTokenForm.vue?vue&type=script&lang=js"
export * from "./DemoTokenForm.vue?vue&type=script&lang=js"
import style0 from "./DemoTokenForm.vue?vue&type=style&index=0&id=70dc8d0e&prod&lang=less&scoped=true"
import style1 from "./DemoTokenForm.vue?vue&type=style&index=1&id=70dc8d0e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dc8d0e",
  null
  
)

export default component.exports